var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 44C137.669 90.9168 99.4457 112 69.3092 112C39.1727 112 0 86.6592 0 59.6696C0 32.6801 7.19355 15.8734 37.5085 5.46611C67.8235 -4.94119 130.331 -2.91677 134 44Z",
    fill: "#FAFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1259 40.8501C94.0623 39.196 94.0623 37.6054 94.0623 36.0785C94.0623 34.8697 93.108 33.9154 91.8992 33.9154C82.5468 33.8517 75.4211 31.1796 69.5043 25.4537C68.6772 24.6266 67.2776 24.6266 66.4505 25.4537C60.5337 31.1796 53.408 33.8517 44.1193 33.8517C42.9105 33.8517 41.9561 34.8061 41.9561 36.0149C41.9561 37.5418 41.9561 39.1323 41.8925 40.8501C41.5744 56.5647 41.1291 78.0052 67.2776 87.0395C67.5321 87.1031 67.7229 87.1667 67.9774 87.1667C68.2319 87.1667 68.4864 87.1031 68.6772 87.0395C94.8257 78.0052 94.3804 56.5647 94.1259 40.8501Z",
    fill: "url(#paint0_radial_37556_42135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4849 48.4211L64.9873 58.9186L60.4702 54.4015C59.6431 53.5744 58.2434 53.5744 57.3527 54.4015C56.5257 55.2286 56.5257 56.6283 57.3527 57.519L63.3968 63.563C63.8421 64.0084 64.3511 64.1992 64.9237 64.1992C65.4963 64.1992 66.0689 64.0084 66.4506 63.563L78.5387 51.4749C79.3658 50.6478 79.3658 49.2482 78.5387 48.3575C77.7117 47.5304 76.312 47.5304 75.4849 48.4211Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_37556_42135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.7504 20.5834) rotate(133.708) scale(133.265 187.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330293,
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330393,
    stopColor: "#D2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.9e1536fd3a81fd8d081b6ee828117195.svg";
export { ForwardRef as ReactComponent };